import { Box, styled, TextField } from "@mui/material";
import { createShouldForwardPropBlockList, IconButton } from "@pmag/ui-components";

interface RootContainerProps {
    showBorderBottom?: boolean;
}

export const RootContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "showBorderBottom",
})<RootContainerProps>(({ theme, showBorderBottom }) => ({
    position: "relative",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: theme.spacing(3, 0),
    ...(showBorderBottom && { borderBottom: `1px solid ${theme.palette.core.grey._30}` }),
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    top: 0,
    right: 0,
    marginRight: `-${theme.spacing(2)}`,
}));

export const TopContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    padding: theme.spacing(0, 2, 2),
}));

export const ArticleImage = styled("img")(({ theme }) => ({
    width: 60,
    height: 60,
    objectFit: "contain",
    marginRight: theme.spacing(3),
}));

export const ArticleInfoContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 2,
}));

export const ArticleInfoBottomContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
}));

export const BottomContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: theme.spacing(2),
}));

export const RightContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));

export const StyledSelect = styled(TextField)({
    height: 32,

    "& .MuiInputBase-root": {
        height: 32,
    },
});

interface StyledIconButtonProps {
    isActive: boolean;
}

export const StyledIconButton = styled(IconButton, {
    shouldForwardProp: createShouldForwardPropBlockList(["isActive"]),
})<StyledIconButtonProps>(({ theme, isActive }) => ({
    backgroundColor: isActive ? theme.palette.blue._40 : theme.palette.core.grey._30,
    "&:hover": {
        backgroundColor: isActive ? theme.palette.blue._50 : theme.palette.core.grey._40,
    },
}));

export const LineNumberChip = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.core.grey._70,
    borderBottomRightRadius: 12,
    borderTopRightRadius: 12,
    height: 24,
    padding: theme.spacing(0, 4),
}));
